export default __webpack_public_path__ + "static/media/download_app_bg_desk.d97fd6fe.svg";